import { useTranslate } from '@tolgee/react';
import { GetStaticProps } from 'next';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import Container from '@amf/shared/components/layout/Container';
import ContactSend from '@amf/shared/components/contact/ContactSend';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';

interface ContactPageProps extends NavigationProps {}

export default function ContactPage({ navigation, partners }: ContactPageProps) {
  const { t } = useTranslate();
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <div className='ContactPage'>
        <Layout navigation={navigation} partners={partners}>
          <Meta title={t('contact.title')} />
          <Container>
            <h1>{t('contact.title')}</h1>
            <div className='ContactPage__content'>
              <ContactSend buttonProps={{ variant: 'dark' }} />
              <div className='ContactPage__info'>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.info.title')}</h2>
                  <address>
                    Malý fotbal Olomouc, z.s.
                    <br />
                    Střední novosadská 202/48
                    <br />
                    779 00 Olomouc - Nové Sady
                  </address>
                  <p>
                    <a href='mailto:predseda@mfolomouc.cz'>predseda@mfolomouc.cz</a>
                    <br />
                    <a href='tel:+420603226907'>+420 603 226 907</a>
                  </p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.billing.title')}</h2>
                  <address>
                    <strong>Malý fotbal Olomouc, z.s.</strong>
                    <br />
                    Střední novosadská 202/48
                    <br />
                    779 00 Olomouc - Nové Sady
                  </address>
                  <p>IČ: 69210926</p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.social.title')}</h2>
                  <p>
                    <a
                      href='https://www.facebook.com/people/Malý-fotbal-Olomouc/100024207203631/'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Facebook
                    </a>
                    <br />
                    <a
                      href='https://www.instagram.com/malyfotbalolomouc'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Instagram
                    </a>
                    <br />
                    <a
                      href='https://www.youtube.com/channel/UCmKSbl3fCdwxQhyKpKsPktw'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Youtube
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </Container>
        </Layout>
      </div>
    </GoogleReCaptchaProvider>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
    revalidate: 10,
  };
};
